/**
 * Generated runtime TestId mirror for frontend/src/components/shared/UnifiedSearchBar.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const UnifiedSearchBarTestIds = {
  btnClearSearch: "btn-clear-search",
  btnFilterTrigger: "btn-filter-trigger",
  inputSearch: "input-search",
  unifiedSearchBar: "unified-search-bar",
  chip: (key: string) => `chip-${key}`,
  chipPrefix: () => "chip-" as TestIdPrefix,
  chipAttr: (attrName: string) => `chip-attr-${attrName}`,
  chipAttrPrefix: () => "chip-attr-" as TestIdPrefix
} as const;
